import MemoryMap from "nrf-intel-hex";


// tslint:disable:no-bitwise

const table = [
  0x0000, 0x1021, 0x2042, 0x3063, 0x4084, 0x50a5, 0x60c6, 0x70e7,
  0x8108, 0x9129, 0xa14a, 0xb16b, 0xc18c, 0xd1ad, 0xe1ce, 0xf1ef,
  0x1231, 0x0210, 0x3273, 0x2252, 0x52b5, 0x4294, 0x72f7, 0x62d6,
  0x9339, 0x8318, 0xb37b, 0xa35a, 0xd3bd, 0xc39c, 0xf3ff, 0xe3de,
  0x2462, 0x3443, 0x0420, 0x1401, 0x64e6, 0x74c7, 0x44a4, 0x5485,
  0xa56a, 0xb54b, 0x8528, 0x9509, 0xe5ee, 0xf5cf, 0xc5ac, 0xd58d,
  0x3653, 0x2672, 0x1611, 0x0630, 0x76d7, 0x66f6, 0x5695, 0x46b4,
  0xb75b, 0xa77a, 0x9719, 0x8738, 0xf7df, 0xe7fe, 0xd79d, 0xc7bc,
  0x48c4, 0x58e5, 0x6886, 0x78a7, 0x0840, 0x1861, 0x2802, 0x3823,
  0xc9cc, 0xd9ed, 0xe98e, 0xf9af, 0x8948, 0x9969, 0xa90a, 0xb92b,
  0x5af5, 0x4ad4, 0x7ab7, 0x6a96, 0x1a71, 0x0a50, 0x3a33, 0x2a12,
  0xdbfd, 0xcbdc, 0xfbbf, 0xeb9e, 0x9b79, 0x8b58, 0xbb3b, 0xab1a,
  0x6ca6, 0x7c87, 0x4ce4, 0x5cc5, 0x2c22, 0x3c03, 0x0c60, 0x1c41,
  0xedae, 0xfd8f, 0xcdec, 0xddcd, 0xad2a, 0xbd0b, 0x8d68, 0x9d49,
  0x7e97, 0x6eb6, 0x5ed5, 0x4ef4, 0x3e13, 0x2e32, 0x1e51, 0x0e70,
  0xff9f, 0xefbe, 0xdfdd, 0xcffc, 0xbf1b, 0xaf3a, 0x9f59, 0x8f78,
  0x9188, 0x81a9, 0xb1ca, 0xa1eb, 0xd10c, 0xc12d, 0xf14e, 0xe16f,
  0x1080, 0x00a1, 0x30c2, 0x20e3, 0x5004, 0x4025, 0x7046, 0x6067,
  0x83b9, 0x9398, 0xa3fb, 0xb3da, 0xc33d, 0xd31c, 0xe37f, 0xf35e,
  0x02b1, 0x1290, 0x22f3, 0x32d2, 0x4235, 0x5214, 0x6277, 0x7256,
  0xb5ea, 0xa5cb, 0x95a8, 0x8589, 0xf56e, 0xe54f, 0xd52c, 0xc50d,
  0x34e2, 0x24c3, 0x14a0, 0x0481, 0x7466, 0x6447, 0x5424, 0x4405,
  0xa7db, 0xb7fa, 0x8799, 0x97b8, 0xe75f, 0xf77e, 0xc71d, 0xd73c,
  0x26d3, 0x36f2, 0x0691, 0x16b0, 0x6657, 0x7676, 0x4615, 0x5634,
  0xd94c, 0xc96d, 0xf90e, 0xe92f, 0x99c8, 0x89e9, 0xb98a, 0xa9ab,
  0x5844, 0x4865, 0x7806, 0x6827, 0x18c0, 0x08e1, 0x3882, 0x28a3,
  0xcb7d, 0xdb5c, 0xeb3f, 0xfb1e, 0x8bf9, 0x9bd8, 0xabbb, 0xbb9a,
  0x4a75, 0x5a54, 0x6a37, 0x7a16, 0x0af1, 0x1ad0, 0x2ab3, 0x3a92,
  0xfd2e, 0xed0f, 0xdd6c, 0xcd4d, 0xbdaa, 0xad8b, 0x9de8, 0x8dc9,
  0x7c26, 0x6c07, 0x5c64, 0x4c45, 0x3ca2, 0x2c83, 0x1ce0, 0x0cc1,
  0xef1f, 0xff3e, 0xcf5d, 0xdf7c, 0xaf9b, 0xbfba, 0x8fd9, 0x9ff8,
  0x6e17, 0x7e36, 0x4e55, 0x5e74, 0x2e93, 0x3eb2, 0x0ed1, 0x1ef0
];

const crcEval = (buffer: Uint8Array) => {
  let crc = 0xFFFF;

  for (const b of buffer) {
    // tslint:disable-next-line:no-bitwise
    crc = ((crc << 8) ^ table[(crc >> 8 ^ b)]) & 0xFFFF;
  }
  return crc;
};

export const checkBlock = (block: string) => {
  const bytes = Uint8Array.from(atob(block), c => c.charCodeAt(0));
  const len = bytes[0] * 256 + bytes[1];
  const isGood = len === bytes.length - 2;

  const dv = new DataView(bytes.buffer);
  const index = dv.getUint16(2, true);
  const resCrc = crcEval(bytes.slice(2));
  return (isGood && !resCrc) ? index : -1;
};

export const evalJson = (
  data: string[],
  resDict: Record<string, string>,
  totalBlocks: number,
  foundIndexes: boolean[],
  isHrv = false,
  isPadded = false,
) => {

  let first = true;
  for (const blockRaw of data) {
    try {
      const block = isPadded ? blockRaw.slice(1, -1) : blockRaw;
      const res = checkBlock(block);
      let resInd = (res === 1 && first && !isHrv) ? 0 : res;
      if (resInd === 0 && res === 1 && first && resDict[0] && !resDict[1]) {
        resInd = 1;
      }
      if (resInd > -1) {
        resDict[resInd] = block;
        foundIndexes[isHrv ? resInd - 1 : resInd] = true;
      }
    } catch (e) {
    }
    first = false;
  }
  const missingKeys = [];
  const missingKeysRaw = [];
  // HRV read-flash positions are zero-based, so -1 is needed as the
  // "no missing range yet" sentinel; block 0 is a valid missing position.
  let lastMissingKey = isHrv ? -1 : 0;
  let range = 0;
  let gap = 0;
  const maxGapRange = 600;

  for (let i = 0; i < totalBlocks; i++) {
    const hasMissingRange = isHrv ? lastMissingKey >= 0 : Boolean(lastMissingKey);
    // HRV block headers are one-based, while read-flash ranges are zero-based.
    // HRV blocks are stored at `resInd - 1` above and must be inspected using
    // the same zero-based position here.
    if (foundIndexes[i]) {
      if (hasMissingRange) {
        if (gap <= maxGapRange) {
          gap += 1;
        } else {
          missingKeys.push([lastMissingKey, range]);
          lastMissingKey = 0;
          range = 0;
          gap = 0;
        }
      }
      continue;
    }
    if (hasMissingRange) {
      range += 1 + gap;
      gap = 0;
    } else {
      lastMissingKey = i;
      range = 1;
      gap = 0;
    }
    missingKeysRaw.push(i);
  }
  if (isHrv ? lastMissingKey >= 0 : lastMissingKey) {
    missingKeys.push([lastMissingKey, range]);
  }

  if (Object.keys(resDict).length === totalBlocks) {
    const entries = Object.entries(resDict);

    // Step 2: Sort the entries by key
    const sortedEntries = entries.sort((a, b) => {
      if (Number(a[0]) < Number(b[0])) { return -1; }
      if (Number(a[0]) > Number(b[0])) { return 1; }
      return 0;
    });

    // Step 3: Extract the values from the sorted entries
    const sortedValues = sortedEntries.map(entry => entry[1]);
    return {status: true, data: sortedValues, goodBlocks: totalBlocks, ok: true};
  } else {
    return {status: false, data: missingKeys, goodBlocks: totalBlocks - missingKeysRaw.length, ok: true};
  }
  // console.log(innerPart[0].slice(1, -1));
};

export const evalJsonWrapper = (
  data: string,
  resDict: Record<string, string>,
  totalBlocks: number,
  foundIndexes: boolean[],
  isHrv = false) => {
  let innerPartArr;
  let innerPart;

  if (!data.includes('data":[')) {
    return {status: false, data: [], goodBlocks: 0, ok: false};
  }
  innerPartArr = data.split('data":[');
  if (innerPartArr.length !== 2) {
    return {status: false, data: [], goodBlocks: 0, ok: false};
  }
  innerPart = innerPartArr[1];

  if (!innerPart.includes(']')) {
    return {status: false, data: [], goodBlocks: 0, ok: false};
  }
  innerPartArr = innerPart.split(']');
  if (innerPartArr.length !== 2) {
    return {status: false, data: [], goodBlocks: 0, ok: false};
  }
  innerPart = innerPartArr[0];

  if (!innerPart.includes(',')) {
    innerPartArr = [innerPart];
    // return {status: false, data: [], goodBlocks: 0, ok: false};
  } else {
    innerPartArr = innerPart.split(',');
  }
  return evalJson(innerPartArr, resDict, totalBlocks, foundIndexes, isHrv, true);
};


// Methods used to evaluate handRecognition

const parseBlock = (block: string): number[] => {
  const bytes = Uint8Array.from(atob(block), c => c.charCodeAt(0));
  const dv = new DataView(bytes.buffer);
  const res = [];
  for (let i = 0; i < 8; i++) {
    const num = dv.getUint16(5 + 3 * i, true);
    res.push(num);
  }
  return res;
};

const processBlocks = (inputData: string[], skipSize: number) => {
  const dataParsed = [];
  for (let i = 0; i < inputData.length; i++) {
    if (((i + 1) % skipSize) === 0) {
      if (!checkBlock(inputData[i])) {
        return [];
      }
      dataParsed.push(parseBlock(inputData[i]));
    }
  }
  return dataParsed;
};

const evaluate = (
  data: number[][],
  ledDicts: {near: number[], middle: number[], far: number[], dark: boolean}[],
  ledsToSkip: number[]
) => {
  const res = {
    near: 0,
    middle: 0,
    far: 0,
    dark: 0
  };
  const count = {
    near: 0,
    middle: 0,
    far: 0,
    dark: 0
  };

  for (let i = 0; i < data.length; i++) {
    if (ledsToSkip.includes(i)) {
      continue;
    }
    // data[i] = data[i].map((el) => el ** factor);
    const ledDict = ledDicts[i];
    if (ledDict.dark) {
      res.dark += data[i].reduce((a, b) => a + b);
      count.dark += 8;
    } else {
      for (const led of ledDict.near) {
        res.near += data[i][led - 1];
      }
      for (const led of ledDict.middle) {
        res.middle += data[i][led - 1];
      }
      for (const led of ledDict.far) {
        res.far += data[i][led - 1];
      }
      count.near += ledDict.near.length;
      count.middle += ledDict.middle.length;
      count.far += ledDict.far.length;
    }
  }
  res.dark /= count.dark;
  res.near /= count.near;
  res.middle /= count.middle;
  res.far /= count.far;

  return res;
};

export const parseHandRecognition = (inputData: string[], handOff: boolean, start: number, count: number, cycles: number) => {


  const ledsToSkip: number[] = handOff ? [4, 5, 9] : [6, 12];

  const ledDicts = handOff ?
    [
      {near: [], middle: [], far: [], dark: true},
      {near: [4, 3], middle: [1, 2], far: [5, 6, 7, 8], dark: false},
      {near: [1, 2], middle: [3, 4, 5, 6], far: [7, 8], dark: false},
      {near: [5], middle: [1, 6], far: [2, 3, 4, 7, 8], dark: false},
      {near: [], middle: [], far: [], dark: true},
      {near: [], middle: [], far: [], dark: true},
      {near: [3], middle: [1, 4], far: [2, 5, 6, 7, 8], dark: false},
      {near: [1, 2], middle: [3, 4, 5, 6], far: [7, 8], dark: false},
      {near: [5, 6], middle: [1, 2], far: [3, 4, 7, 8], dark: false},
      {near: [], middle: [], far: [], dark: true},
    ] :
    [
      {near: [], middle: [], far: [], dark: true},
      {near: [8], middle: [2, 4], far: [1, 3, 5, 6, 7], dark: false},
      {near: [8], middle: [2, 4], far: [1, 3, 5, 6, 7], dark: false},
      {near: [2, 4], middle: [1, 3, 8], far: [5, 6, 7], dark: false},
      {near: [1, 3], middle: [2, 4, 5], far: [6, 7, 8], dark: false},
      {near: [1, 3], middle: [2, 4, 5], far: [6, 7, 8], dark: false},
      {near: [], middle: [], far: [], dark: true},
      {near: [1, 5], middle: [2, 3, 6], far: [4, 7, 8], dark: false},
      {near: [1, 5], middle: [2, 3, 6], far: [4, 7, 8], dark: false},
      {near: [2, 6], middle: [1, 5, 7], far: [3, 4, 8], dark: false},
      {near: [7], middle: [2, 6], far: [1, 3, 4, 5, 8], dark: false},
      {near: [7], middle: [2, 6], far: [1, 3, 4, 5, 8], dark: false},
      {near: [], middle: [], far: [], dark: true},
    ];

  const res = {
    dark: 1,
    near: 1,
    middle: 1,
    far: 1,
  };
  const dataParsed = processBlocks(inputData, cycles + 2);
  if (dataParsed.length > 0) {
    const resParsed = evaluate(dataParsed, ledDicts, ledsToSkip);
    res.dark = Math.max(1, resParsed.dark);
    res.near = Math.max(1, resParsed.near);
    res.middle = Math.max(1, resParsed.middle);
    res.far = Math.max(1, resParsed.far);
  } else {
    return false;
  }

  const darkCheck = res.dark < 3;
  const farCheck = (res.near / res.far) > 10;
  const midCheck = (res.near / res.middle) > 2.5;
  const handOn = darkCheck && farCheck && midCheck;
  return handOff ? !handOn : handOn;
};

export const hexToBin = (dataHex: string, targetLength = 0) => {

  const memMap = MemoryMap.fromHex(dataHex);
  let minAddr = Infinity;
  let maxAddr = -Infinity;

  for (const [addr, data] of memMap.entries()) {
    minAddr = Math.min(minAddr, addr);
    maxAddr = Math.max(maxAddr, addr + data.byteLength);
  }
  if (targetLength === 0) {
    targetLength = maxAddr - minAddr;
  }

  const fullImage = new Uint8Array(targetLength).fill(0xFF); // or 0x00 if preferred

  for (const [addr, data] of memMap.entries()) {
    fullImage.set(data, addr - minAddr);
  }
  const chunks = [];
  for (let i = 0; i < fullImage.length; i += 256) {
    const chunk = fullImage.slice(i, i + 256);
    const padded = new Uint8Array(256).fill(0xFF);
    padded.set(chunk);
    chunks.push(padded.buffer);
  }
  const combined = new Uint8Array(chunks.length * 256);
  chunks.forEach((buf, i) => {
    combined.set(new Uint8Array(buf), i * 256);
  });

  const paddingByte = 0x00;

  const arrayBuffers = [];

  for (let addr = 0; addr < combined.byteLength; addr += 256) {
    const chunk = combined.slice(addr, addr + 256);
    const padded = new Uint8Array(256).fill(paddingByte);
    padded.set(chunk);
    arrayBuffers.push(padded.buffer);
  }

  // Optionally concatenate into one ArrayBuffer
  const totalLength = arrayBuffers.length * 256;
  const finalBuffer = new Uint8Array(totalLength);

  arrayBuffers.forEach((buf, index) => {
    finalBuffer.set(new Uint8Array(buf), index * 256);
  });
  return {
  dataBin: finalBuffer,
    startAddr: minAddr
  };
};


export const blockifyUpdate = (updateRaw: Uint8Array, sep = true, b64 = true) => {
  const crcEvalBlock = (buffer: Uint8Array) => {
    let crc = 0xFFFF;

    for (const b of buffer) {
      // tslint:disable-next-line:no-bitwise
      crc = ((crc << 8) ^ table[(crc >> 8 ^ b)]) & 0xFFFF;
    }
    return crc;
  };

  const encryptDataBlock = (i: number, d: Uint8Array, chunkSizeInner: number) => {
    const length = [Math.floor(chunkSizeInner / 256), chunkSizeInner % 256];
    const index = [i % 256, Math.floor(i / 256)];
    const crc = crcEvalBlock(Uint8Array.from([...index, ...d]));
    const data = Uint8Array.from([...length, ...index, ...d, Math.floor(crc / 256), crc % 256]);
    if (b64) {
      return btoa(String.fromCharCode(...data));
    } else {
      return String.fromCharCode(...data);
    }
  };
  let runningIndex = 0;
  const chunkSize = 256;
  let res = '';
  while (true) {
    const d = updateRaw.slice(runningIndex * chunkSize, (runningIndex + 1) * chunkSize);
    if (d.length === 0) {
      break;
    }
    const d2 = [...d, ...Uint8Array.from(Array(chunkSize).fill(0))].slice(0, chunkSize);
    // @ts-ignore
    const updateData = encryptDataBlock(runningIndex, d2, chunkSize);
    res += updateData + (sep ? ',' : '' );
    runningIndex++;
  }
  return res;
};

export const hexToBinNuv = (dataHex: string) => {
  const u16ToHexBE = (n: number) => {
    if (!Number.isInteger(n) || n < 0 || n > 0xFFFF) {
      throw new RangeError('n must be a 16-bit unsigned integer');
    }
    const bytes = new Uint8Array(2);
    bytes[0] = (n >>> 8) & 0xFF;
    bytes[1] = n & 0xFF;
    return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('').toUpperCase();
  };

  const u32ToHexBE = (n: number) => {
    if (!Number.isInteger(n) || n < 0 || n > 0xFFFFFFFF) {
      throw new RangeError('n must be a 32-bit unsigned integer');
    }
    const bytes = new Uint8Array(4);
    bytes[0] = (n >>> 24) & 0xFF;
    bytes[1] = (n >>> 16) & 0xFF;
    bytes[2] = (n >>> 8) & 0xFF;
    bytes[3] = n & 0xFF;
    return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('').toUpperCase();
  };

  const crc16CcittFalse = (bytes: Uint8Array) => {
    let crc = 0xFFFF;
    for (const byte of bytes) {
      crc ^= (byte << 8);
      for (let b = 0; b < 8; b++) {
        if (crc & 0x8000) {
          crc = ((crc << 1) ^ 0x1021) & 0xFFFF;
        } else {
          crc = (crc << 1) & 0xFFFF;
        }
      }
    }
    return crc >>> 0;
  };

  const encryptData = (i: number, d: Uint8Array, chunkSizeInner: number) => {
    const dataB64 = btoa(String.fromCharCode(...d));
    const addr = i * chunkSizeInner;
    const addressToSend = u32ToHexBE(addr);
    const block = '0' + addressToSend + dataB64;
    const bytes = new TextEncoder().encode(block);
    const crc = crc16CcittFalse(bytes);
    const crcHexBE = crc.toString(16).padStart(4, '0').toUpperCase();
    let dataToSend = block + crcHexBE;
    const lengthToSend = u16ToHexBE(dataToSend.length);
    dataToSend = ';' + lengthToSend + dataToSend;
    return dataToSend;
  };

  const blockifyNuvotonUpdate = (updateRaw: Uint8Array, index: number) => {
    const chunkSize = 32;
    return encryptData(index, updateRaw, chunkSize);
  };

  const memMap = MemoryMap.fromHex(dataHex);
  let minAddr = Infinity;
  let maxAddr = -Infinity;

  for (const [addr, data] of memMap.entries()) {
    minAddr = Math.min(minAddr, addr);
    maxAddr = Math.max(maxAddr, addr + data.byteLength);
  }
  const targetLength = maxAddr - minAddr;

  const fullImage = new Uint8Array(targetLength).fill(0x00);

  for (const [addr, data] of memMap.entries()) {
    fullImage.set(data, addr - minAddr);
  }
  const chunks = [];
  for (let i = 0; (i * 32) < fullImage.length; i++) {
    const chunk = fullImage.slice(i * 32, (i + 1) * 32);
    chunks.push(blockifyNuvotonUpdate(chunk, i));
  }
  return chunks;
};

export const readBlobAsText = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsText(blob);
  });
};
